import {Button} from '@mui/material';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {getWidgetExportData} from 'redux/actions';
import {TableColumnVisibility} from 'shared/constants/UiWisePropType';
import AppConfirmDialog from '../AppConfirmDialog';

const ALERT_CONFIG = {
  idFieldName: 'exportData',
  title: 'Export Options',
  fields: [
    {
      name: 'exportScope',
      label: 'Pages to Export',
      fieldtype: 'optionField',
      optioncontrol: 'radioGroup',
      value: 'current',
      options: [
        {value: 'current', label: 'Current Page'},
        {value: 'all', label: 'All Pages'},
      ],
    },
    {
      name: 'reportType',
      label: 'Format',
      fieldtype: 'optionField',
      optioncontrol: 'radioGroup',
      value: 'csv',
      options: [
        {value: 'csv', label: 'CSV'},
        {value: 'pdf', label: 'PDF'},
      ],
    },
  ],
  actions: [
    {
      showas: 'button',
      actiontype: 'submit',
      label: 'Export',
      color: 'primary',
      variant: 'contained',
    },
    {
      showas: 'button',
      actiontype: 'cancel',
      label: 'Cancel',
      color: 'secondary',
      variant: 'outlined',
    },
  ],
};

const AppAsyncExport = ({widgetid, tableParams, disabled, dataColumns}) => {
  const dispatch = useDispatch();
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const onDialogCancel = () => setDialogOpen(false);

  const onDialogConfirm = (values) => {
    const isAll = values.exportScope === 'all';

    const requestPayload = {
      ...tableParams,
      page: isAll ? -1 : tableParams.page,
      pageSize: isAll ? 99999 : tableParams.pageSize,
      reportType: values.reportType,
    };

    dispatch(getWidgetExportData(widgetid, requestPayload, dataColumns));
    setDialogOpen(false);
  };

  return (
    <>
      <Button
        id={`export-${widgetid}`}
        onClick={handleOpenDialog}
        color='secondary'
        variant='outlined'
        disabled={disabled}
        sx={{
          position: 'relative',
          minWidth: 140,
          ml: 2,
          py: 1.5,
          fontSize: '0.8125rem',
          letterSpacing: '1.2px',
        }}
      >
        Export
      </Button>

      <AppConfirmDialog
        widgetid={widgetid}
        alertSpec={ALERT_CONFIG}
        isOpen={isDialogOpen}
        onConfirm={onDialogConfirm}
        onClose={onDialogCancel}
      />
    </>
  );
};

AppAsyncExport.propTypes = {
  widgetid: PropTypes.string.isRequired,

  tableParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    sortOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
    sortColumn: PropTypes.string.isRequired,
    search: PropTypes.string,
  }).isRequired,

  dataColumns: PropTypes.arrayOf(TableColumnVisibility),
  disabled: PropTypes.bool,
};

export default AppAsyncExport;
